(function() {
  'use strict';

  // ── Mobile Nav ──
  var menuBtn = document.getElementById('js-menu-btn');
  var menuClose = document.getElementById('js-menu-close');
  var mobileNav = document.getElementById('js-mobile-nav');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (menuBtn) menuBtn.addEventListener('click', openMobileNav);
  if (menuClose) menuClose.addEventListener('click', closeMobileNav);
  var checkoutLink = document.getElementById('checkout-link');
  if (checkoutLink) {
  checkoutLink.addEventListener('click', function() {
    closeCart();
  });
}
  window.closeMobileNav = closeMobileNav;

  // ── Cart Drawer ──
  var cartBtn = document.getElementById('js-cart-btn');
  var cartClose = document.getElementById('js-cart-close');
  var cartDrawer = document.getElementById('js-cart-drawer');
  var cartOverlay = document.getElementById('js-cart-overlay');
  var cartCount = document.getElementById('js-cart-count');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartBtn) {
    cartBtn.addEventListener('click', function(e) {
      // Only open drawer on non-cart pages; on cart page go to /cart
      if (window.location.pathname.indexOf('/cart') === -1) {
        e.preventDefault();
        openCart();
      }
    });
  }
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ── Keyboard close ──
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeMobileNav();
      closeCart();
    }
  });

  // ── Add to cart AJAX ──
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      var data = { items: [{ id: formData.get('id'), quantity: parseInt(formData.get('quantity')) || 1 }] };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(data)
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        return fetch('/cart.js');
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cartCount) {
          cartCount.textContent = cart.item_count;
          cartCount.dataset.count = cart.item_count;
        }
        openCart();
      })
      .catch(function(err) { console.error('Cart error:', err); });
    });
  }

})();
document.addEventListener('DOMContentLoaded', function () {
  const thumbnails = document.querySelectorAll('.product__media-thumbnail, .thumbnail, [data-media-id]');
  const mainImages = document.querySelectorAll('.product__media img, .product-media img');

  thumbnails.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const img = thumb.querySelector('img');
      if (!img) return;

      const newSrc = img.src.replace('_small', '').replace('_compact', '');

      mainImages.forEach(function (mainImg) {
        mainImg.src = newSrc;
        mainImg.srcset = '';
      });
    });
  });
});


// Product image thumbnail switcher

document.addEventListener('click', function(e) {

  const thumb = e.target.closest('.product-thumbnails img, .thumbnail img, .product__media img');

  if (!thumb) return;

  const mainImage = document.querySelector('.product-gallery img, .product-main-image img, .product__media-main img, .product img');

  if (mainImage) {

    mainImage.src = thumb.src;

    mainImage.srcset = thumb.srcset || '';

  }

});